import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {css, useTheme} from "@emotion/react";

import {flexAbsoluteCenter, mr, textAlign} from "@pg-design/helpers-css";
import {Rating} from "@pg-design/rating";
import {Text} from "@pg-design/text-module";
import {pluralize} from "@pg-mono/string-utils";

import {addNotification} from "../../../notifications/state/notifications_slice";
import {postArticleRating} from "../../api/post_article_rating";
import {hitClickOnArticleRating} from "../../tracking/article_events";

interface IProps {
    articleId: number;
    ratings: {
        average: number | null;
        total: number;
    };
    isHorizontal?: boolean;
    className?: string;
}

const votePluralize = pluralize(["głosu", "głosów", "głosów"]);

export const ArticleRating: React.FC<IProps> = (props) => {
    const {
        articleId,
        isHorizontal,
        ratings: {average, total}
    } = props;

    const dispatch = useDispatch();
    const theme = useTheme();

    const [currentRating, setCurrentRating] = useState(average);
    const [isReadOnly, setReadOnly] = useState(false);

    const onRatingChange = (value: number) => {
        postArticleRating({article: articleId, value})
            .then(() => {
                setCurrentRating(value);

                dispatch(addNotification({type: "success", content: "Ocena artykułu została dodana poprawnie"}));
            })
            .catch((errors: string[]) => {
                if (errors.length) {
                    errors.forEach((content) => {
                        dispatch(addNotification({type: "failure", content}));
                    });
                } else {
                    dispatch(addNotification({type: "failure", content: "Coś poszło nie tak. Spróbuj ponownie później."}));
                }
            })
            .finally(() => setReadOnly(true));
    };

    const onRatingClick = (value: number) => {
        onRatingChange(value);

        if (currentRating) {
            const type = currentRating === value ? "equal" : currentRating > value ? "down" : "top";

            hitClickOnArticleRating({article_id: articleId, type});
        }
    };

    return isHorizontal ? (
        <div className={props.className} css={flexAbsoluteCenter}>
            <Text color={theme.colors.gray[600]} css={mr(2)} variant="info_txt_1">
                OCEŃ ARTYKUŁ:
            </Text>
            <Rating score={currentRating || 0} isReadOnly={isReadOnly} onClick={onRatingClick} />
        </div>
    ) : (
        <div className={props.className} css={textAlign("right")}>
            {average !== null && !!total && (
                <>
                    <Text align="right" color={theme.colors.gray[600]} mb="0.8rem" variant="info_txt_1">
                        Średnia ocen {average}/5 na podstawie {total} {votePluralize(total)}
                    </Text>
                    <div css={ratingWrapper}>
                        <Rating score={currentRating || 0} isReadOnly={isReadOnly} onClick={onRatingClick} />
                    </div>
                </>
            )}
        </div>
    );
};

const ratingWrapper = css`
    display: flex;
    justify-content: end;
`;
import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {css, useTheme} from "@emotion/react";

import {flexAbsoluteCenter, mr, textAlign} from "@pg-design/helpers-css";
import {Rating} from "@pg-design/rating";
import {Text} from "@pg-design/text-module";
import {pluralize} from "@pg-mono/string-utils";

import {addNotification} from "../../../notifications/state/notifications_slice";
import {postArticleRating} from "../../api/post_article_rating";
import {hitClickOnArticleRating} from "../../tracking/article_events";

interface IProps {
    articleId: number;
    ratings: {
        average: number | null;
        total: number;
    };
    isHorizontal?: boolean;
    className?: string;
}

const votePluralize = pluralize(["głosu", "głosów", "głosów"]);

export const ArticleRating: React.FC<IProps> = (props) => {
    const {
        articleId,
        isHorizontal,
        ratings: {average, total}
    } = props;

    const dispatch = useDispatch();
    const theme = useTheme();

    const [currentRating, setCurrentRating] = useState(average);
    const [isReadOnly, setReadOnly] = useState(false);

    const onRatingChange = (value: number) => {
        postArticleRating({article: articleId, value})
            .then(() => {
                setCurrentRating(value);

                dispatch(addNotification({type: "success", content: "Ocena artykułu została dodana poprawnie"}));
            })
            .catch((errors: string[]) => {
                if (errors.length) {
                    errors.forEach((content) => {
                        dispatch(addNotification({type: "failure", content}));
                    });
                } else {
                    dispatch(addNotification({type: "failure", content: "Coś poszło nie tak. Spróbuj ponownie później."}));
                }
            })
            .finally(() => setReadOnly(true));
    };

    const onRatingClick = (value: number) => {
        onRatingChange(value);

        if (currentRating) {
            const type = currentRating === value ? "equal" : currentRating > value ? "down" : "top";

            hitClickOnArticleRating({article_id: articleId, type});
        }
    };

    return isHorizontal ? (
        <div className={props.className} css={flexAbsoluteCenter}>
            <Text color={theme.colors.gray[600]} css={mr(2)} variant="info_txt_1">
                OCEŃ ARTYKUŁ:
            </Text>
            <Rating score={currentRating || 0} isReadOnly={isReadOnly} onClick={onRatingClick} />
        </div>
    ) : (
        <div className={props.className} css={textAlign("right")}>
            {average !== null && !!total && (
                <>
                    <Text align="right" color={theme.colors.gray[600]} mb="0.8rem" variant="info_txt_1">
                        Średnia ocen {average}/5 na podstawie {total} {votePluralize(total)}
                    </Text>
                    <div css={ratingWrapper}>
                        <Rating score={currentRating || 0} isReadOnly={isReadOnly} onClick={onRatingClick} />
                    </div>
                </>
            )}
        </div>
    );
};

const ratingWrapper = css`
    display: flex;
    justify-content: end;
`;
